module.exports = __webpack_public_path__ + "img/tonga-logo-icon.d1669809.png";